<template>
    <v-bottom-navigation
        v-if="
            $vuetify.breakpoint.mdAndDown && $store.get('auth/role') === 'user'
        "
        color="primary"
        app
        fixed
        grow
        shift
    >
        <template v-for="(menu, i) in activeMenus">
            <v-btn
                v-if="isMenuVisible(menu)"
                :key="i"
                :to="menu.to"
                :exact="menu.exact"
            >
                <span>{{ menu.name }}</span>
                <v-icon>{{ menu.icon }}</v-icon>
            </v-btn>
        </template>
    </v-bottom-navigation>

    <v-navigation-drawer
        v-else
        v-model="drawer"
        app
        clipped
    >
        <v-list nav>
            <v-list-item v-if="$store.get('auth/role') === 'user'">
                <period-selector></period-selector>
            </v-list-item>

            <v-divider></v-divider>

            <template v-for="(menu, i) in activeMenus">
                <v-list-item
                    v-if="isMenuVisible(menu)"
                    :key="i"
                    :to="menu.to"
                    :exact="menu.exact"
                >
                    <v-list-item-icon>
                        <v-icon>{{ menu.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ menu.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { sync } from 'vuex-pathify'
import PeriodSelector from './period/PeriodSelector'

export default {
    components: {
        PeriodSelector,
    },

    data() {
        return {
            menus: {
                user: [
                    {
                        icon: 'mdi-view-dashboard-outline',
                        name: 'Dashboard',
                        to: { name: 'dashboard' },
                        exact: true,
                    },
                    {
                        icon: 'mdi-lightbulb-outline',
                        name: 'Tryout',
                        to: { name: 'tryout' },
                        hideOnContentRegistration: true,
                    },
                    {
                        icon: 'mdi-checkbox-marked-outline',
                        name: 'Pembahasan',
                        to: { name: 'grade' },
                        hideOnContentRegistration: true,
                    },
                    {
                        icon: 'mdi-video',
                        name: 'Kelon',
                        to: { name: 'kelon' },
                        showWhenKelonAvailable: true,
                    },
                    {
                        icon: 'mdi-help-circle-outline',
                        name: 'Bantuan',
                        to: { name: 'help' },
                    },
                ],
                enrollment: [
                    {
                        icon: 'mdi-account-plus',
                        name: 'Daftar Baru',
                        to: { name: 'enrollment' },
                    },
                ],
                payment: [
                    {
                        icon: 'mdi-account-plus',
                        name: 'Pendaftaran',
                        to: { name: 'payment' },
                    },
                    {
                        icon: 'mdi-help-circle-outline',
                        name: 'Bantuan',
                        to: { name: 'help' },
                    },
                ],
                groupPayment: [
                    {
                        icon: 'mdi-account-multiple',
                        name: 'Kelompok',
                        to: { name: 'groupPayment' },
                    },
                ],
                admin: [
                    {
                        icon: 'mdi-view-dashboard-outline',
                        name: 'Dashboard',
                        to: { name: 'dashboard' },
                        exact: true,
                    },
                    {
                        icon: 'mdi-account-plus-outline',
                        name: 'Pendaftaran',
                        to: { name: 'registration' },
                    },
                    {
                        icon: 'mdi-link-variant',
                        name: 'Link Pendaftaran',
                        to: { name: 'registrationLink' },
                    },
                    {
                        icon: 'mdi-account-multiple-plus-outline',
                        name: 'Pendaftaran Kelompok',
                        to: { name: 'registration.group' },
                    },
                    {
                        icon: 'mdi-account-outline',
                        name: 'Pengguna',
                        to: { name: 'user.index' },
                    },
                    {
                        icon: 'mdi-chart-donut',
                        name: 'Data Dasar',
                        to: { name: 'base-data' },
                    },
                    {
                        icon: 'mdi-file-question-outline',
                        name: 'Bank soal',
                        to: { name: 'questionbank' },
                    },
                    {
                        icon: 'mdi-lightbulb-outline',
                        name: 'Program',
                        to: { name: 'period' },
                    },
                    {
                        icon: 'mdi-link',
                        name: 'Link',
                        to: { name: 'link' },
                    },
                    {
                        icon: 'mdi-check',
                        name: 'Cek import',
                        to: { name: 'checkimport' },
                    },
                    {
                        icon: 'mdi-help-circle-outline',
                        name: 'Kelola bantuan',
                        to: { name: 'help.manage' },
                    },
                ],
            },
        }
    },

    computed: {
        drawer: sync('ui/drawer'),
        activeMenus() {
            if (this.$store.get('auth/role') === 'user') {
                if (
                    this.$store.get('auth/group_hash') &&
                    !this.$store.get('auth/is_group_active')
                ) {
                    return this.menus.groupPayment
                }

                if (this.$store.get('enrollment/selectedIdx') === 'enroll') {
                    return this.menus.enrollment
                }

                if (!this.$store.get('enrollment/selected@is_active')) {
                    return this.menus.payment
                }
            }

            return this.menus[this.$store.get('auth/role')]
        },
        contentRegistration() {
            return this.$store.get(
                'enrollment/selected@is_content_registration'
            )
        },
        kelonAvailable() {
            return this.$store.get('enrollment/selected@kelon_group_id') != null
        },
        isMenuVisible() {
            return (menu) =>
                menu.showWhenKelonAvailable
                    ? this.kelonAvailable
                    : !(
                          menu.hideOnContentRegistration &&
                          this.contentRegistration
                      )
        },
    },
}
</script>
